import styled from 'styled-components';

export const AlertasContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

// O banner do modal nao encolhe: sem teto, cada alerta rouba altura da linha
// do tempo. A lista rola por dentro e a barra de acoes fica sempre visivel.
// Sem gap: o respiro entre os alertas escondidos vive no ExtrasConteudo, senao
// sobraria um vao de 8px com a area colapsada fechada.
export const AlertasLista = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 22vh;
  min-height: 0;
  overflow-y: auto;
`;

export const ExtrasConteudo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 8px;
`;

export const AlertaLinha = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 6px;
  border-left: 4px solid ${(props) => props.color};
  background: ${(props) => props.background};
`;

export const AlertaTexto = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const AlertaMensagem = styled.span`
  font-size: 14px;
  color: #2d3748;
  line-height: 1.4;
`;

export const AlertaMeta = styled.span`
  font-size: 11px;
  color: #718096;
`;

export const AlertaEscopo = styled.span`
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 600;
  color: #ffffff;
  background: ${(props) => props.color};
  border-radius: 4px;
  padding: 2px 6px;
  white-space: nowrap;
`;

export const AlertaAcoes = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const NovoAlertaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  border: 1px dashed #cbd5e0;
  border-radius: 6px;
`;

export const NovoAlertaLinha = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-end;
  flex-wrap: wrap;
`;

export const CampoInline = styled.div`
  flex: ${(props) => props.flex || 1};
  min-width: ${(props) => props.minWidth || '160px'};
`;

export const BarraTopo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
`;

export const ResumoAlertas = styled.span`
  font-size: 12px;
  color: #718096;
`;

export const ResumoLinha = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;

export const BotaoMais = styled.button`
  border: none;
  background: none;
  padding: 0;
  font-family: 'Kumbh Sans';
  font-size: 12px;
  color: ${(props) => (props.disabled ? '#a0aec0' : '#2670d1')};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  text-decoration: underline;
  white-space: nowrap;
`;
